module.exports = __webpack_public_path__ + "files/2731dc107cf3d242676a752da8be993f.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people_body-1.png
// module id = 494
// module chunks = 76